import { Timestamp } from 'google-protobuf/google/protobuf/timestamp_pb';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { type ValueType } from '../../types';
import { isDaysAgoOperator } from './helpers';

dayjs.extend(utc);

export type ValueTypeConfig = {
  method: string;
  tagType: ValueType;
  convertToDb?: (a: any) => any;
  convertFromDb?: (a: any) => any;
};
export const valuesTypes: ValueTypeConfig[] = [
  {
    method: 'Integer',
    tagType: 'integer',
  },
  {
    method: 'String',
    tagType: 'string',
  },
  {
    method: 'Boolean',
    tagType: 'boolean',
  },
  {
    method: 'List',
    tagType: 'list',
  },
  {
    method: 'Date',
    tagType: 'date',
    convertToDb: (v): Timestamp | number => {
      return typeof v === 'number'
        ? v
        : new Timestamp().setSeconds(dayjs.utc(v).unix());
    },
    convertFromDb: (v: number | Timestamp) => {
      return typeof v === 'number'
        ? v
        : dayjs.unix(v.getSeconds()).utc().format();
    },
  },
  {
    method: 'Price',
    tagType: 'decimal',
  },
  {
    method: 'Version',
    tagType: 'version',
  },
  {
    method: 'Timezone',
    tagType: 'timezone',
  },
];

export type OperatorConfig = {
  method: string;
  operator?: string;
  checkOperator?: (a: string) => boolean;
  getOperator?: (r: any) => string;
};
export const operators: Array<OperatorConfig> = [
  {
    method: 'Eq',
    operator: 'eq',
  },
  {
    method: 'Neq',
    operator: 'noteq',
  },
  {
    method: 'Lte',
    operator: 'lte',
  },
  {
    method: 'Gte',
    operator: 'gte',
  },
  {
    method: 'In',
    operator: 'in',
  },
  {
    method: 'NotIn',
    operator: 'notin',
  },
  {
    method: 'Between',
    operator: 'between',
  },
  {
    method: 'Exists',
    checkOperator: (op) => op === 'any' || op === 'notset',
    getOperator: (r: any) => (r.getExists() ? 'any' : 'notset'),
  },
  {
    method: 'DaysAgo',
    operator: 'daysago',
    checkOperator: isDaysAgoOperator,
  },
];
